import { ColumnsFactory } from "../../../../../../shared/Components/Grid/functions";

export const getColumnDefs = () => {
  return [
    ColumnsFactory.TextColumn("Cod. Pais", "idPais"),
    ColumnsFactory.TextColumn("País", "pais"),
    ColumnsFactory.TextColumn("Zona", "zona"),
    ColumnsFactory.BooleanColumn("Contrat. Detalle", "contratDetalle")
  ];
};
